import React, { useEffect } from 'react';

import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { Input } from '@/components/ui/Input';
import { validatePesel } from '@/features/v2/summaryForms/Validate';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const OWNER_PESEL_NAME = 'owner.pesel';

const InputPesel = ({
  name = OWNER_PESEL_NAME,
  focused,
  index,
  setFocused,
  className = 'col-span-4 md:col-span-2',
  disabled = true,
}: {
  name: string;
  focused: string;
  index?: number;
  setFocused: (value: string) => void;
  className?: string;
  disabled?: boolean;
}) => {
  const { i18n } = useLingui();
  const { trigger, setValue, watch } = useFormContext();

  useEffect(() => {
    if (disabled) {
      setValue(name, '');

      trigger(name);
    }
  }, [disabled, name, setValue, trigger]);

  const otherPESELS =
    name === OWNER_PESEL_NAME
      ? []
      : [watch(`coowners.${(index ?? 0) - 1}.pesel`), watch(OWNER_PESEL_NAME)];

  return (
    <>
      <FormField
        name={name}
        rules={{
          validate: (value: string) =>
            disabled ? true : validatePesel(value, otherPESELS),
        }}
        render={({ field, fieldState }) => {
          const { value, onChange, onBlur, ...restField } = field;
          return (
            <FormItem className={className}>
              <FormControl>
                <Input
                  inputMode="numeric"
                  disabled={disabled}
                  value={value || ''}
                  label={i18n.t('PESEL')}
                  error={fieldState.error?.message}
                  success={
                    focused !== field.name && !fieldState.error && field.value
                  }
                  onChange={(e) => {
                    if (!/^[0-9]*$/.test(e.target.value)) return;
                    if (
                      value?.length >= 11 &&
                      e.target.value?.length > value?.length
                    )
                      return;
                    onChange(e);
                    if (fieldState.error) {
                      trigger(OWNER_PESEL_NAME);
                    }
                  }}
                  onBlur={() => {
                    setFocused('');
                    setTimeout(() => onBlur(), 100);
                  }}
                  onFocus={() => setFocused(field.name)}
                  {...restField}
                />
              </FormControl>
            </FormItem>
          );
        }}
      />
    </>
  );
};

export default InputPesel;
